import script from "./GmxDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxDialog.vue?vue&type=script&setup=true&lang=js"

import "./GmxDialog.vue?vue&type=style&index=0&id=1098b27e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1098b27e"]])

export default __exports__